export default {
    sections: ['details'],
    groups: {
        contact_details: {
            component: {
                template: `<div class="form-row">
                    <div class="col-sm-6">
                        <slot name="import_id" />
                        <slot name="user_id" />
                        <slot name="sender_id" />
                        <slot name="title" />
                        <slot name="subject" />
                        <slot name="latest_status" />
                    </div>
                </div>`
            }
        }
    },
    toolbar: [],
    fields: {
        import_id: {
            label: 'SendGrid ID',
            section: 'details',
            group: 'contact_details',
            position: 0,
        },
        user_id: {
            label: 'SendGrid User ID',
            section: 'details',
            group: 'contact_details',
            position: 1,
        },
        sender_id: {
            label: 'SendGrid Sender ID',
            section: 'details',
            group: 'contact_details',
            position: 2,
        },
        title: {
            group: 'contact_details',
            section: 'details',
            position: 3,
        },
        subject: {
            group: 'contact_details',
            section: 'details',
            position: 4,
        },
        latest_status: {
            group: 'contact_details',
            section: 'details',
            position: 5,
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.campaign.js